var React = require('react');

function ArrowCircleFill (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"black","key":0}),React.createElement("path",{"d":"M17.625 12L13.875 9.83494V14.1651L17.625 12ZM14.25 11.625H6.75V12.375H14.25V11.625Z","fill":"white","key":1})]);
}

ArrowCircleFill.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowCircleFill;

ArrowCircleFill.default = ArrowCircleFill;
